import gql from 'graphql-tag';

export const GetConsultantHistoryListQuery: any = gql`
  query consultantHistoryList($where: ConsultantHistoryListWhereInput!) {
    consultantHistoryList(where: $where) {
      rows {
        id
        content
        description
        creator
        createdAt
      }
      count
    }
  }
`;
